/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ChatStarterType {
    Form = 1,
    Process = 2,
    Definition = 3,
    IssueTemplate = 4,
}
